export const passwordRegEx =
	/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#~§±`{}()<>;:+=_\\[/|\-^.,'"])[A-Za-z\d@$!%*?&#~§±`{}()<>;:+=_\\[/|\-^.,'[\]"№]{10,}$/;
